<form [formGroup]="additionalSettings" (ngSubmit)="submitAdditionalSettings()">

  <div class="row">

    <div class="col-md-4">
      <label for="preferredTimezone">{{'_General_Preferred_Time_Zone_Text_' | translate }}</label>
      <select class="cc-select-dropdown form-control" id="preferredTimezone" formControlName="prefferedTimezone" (change)="onPrefferedTimeZoneChange()">
        <option *ngFor="let preferredTimezone of prefferedTimezonesAvailable" [ngValue]="preferredTimezone.id"
          [selected]="preferredTimezone.id == 1">
          {{preferredTimezone.name}}
        </option>
      </select>
    </div>

    <div class="col-md-4">
      <label for="secondaryNotificationEmail">{{'_General_Secondary_Notification_Email_Text_' | translate }} 
        <ng-template #SecondaryNotificationEmailTooltip let-anchor>
            <div class="tooltip-content">
              <p>{{'_User_Following_Emails_Ts_1_Text_' | translate }}</p>
                <ul>
                  <li>{{'_User_Following_Emails_Ts_2_Text_' | translate }}</li>
                  <li>{{'_User_Following_Emails_Ts_3_Text_' | translate }}</li>
                  <li>{{'_User_Following_Emails_Ts_4_Text_' | translate }}</li>
                  <li>{{'_User_Following_Emails_Ts_5_Text_' | translate }}</li>
                </ul>
            </div>
          </ng-template>
        <span class="fas fa-info-circle" kendoTooltip [tooltipTemplate]="SecondaryNotificationEmailTooltip" tooltipClass="kendo-tooltip-formatted" title=""></span></label>
      <input id="secondaryNotificationEmail" class="form-control" formControlName="secondaryNotificationEmail"
        type="email" maxlength="256">
      <div *ngIf="isSecondaryNotificationEmailInvalid(secondaryNotificationEmail)">
        <div class="cc-validation" *ngIf="secondaryNotificationEmail?.errors?.invalidEmail">
          {{'_General_Invalid_Secondary_Notification_Email_Text_' | translate }}
        </div>
      </div>
    </div>

    <div class="col-md-4 checkbox d-flex flex-column justify-content-center">
      <label for="secondaryEmailAsOptionalAttendee" [disableIf]="disableOptionalAttendeeCheckbox()">
        <input type="checkbox" id="secondaryEmailAsOptionalAttendee" formControlName="secondaryEmailAsOptionalAttendee" class="cc-filter-checkbox" kendoCheckBox />
        <span>{{'_User_Appointment_Settings_Optional_Appointment_Attendee_Label_Text_' | translate }}</span>
      </label>
    </div>

  </div>

  <div class="row">

    <div class="col-md-4 checkbox">
      <label>
        <input id="optInDailyPersonalEmails" formControlName="optInDailyPersonalEmails" class="cc-filter-checkbox"
          type="checkbox" kendoCheckBox />
        {{'_User_Appointment_Settings_Daily_Personal_Summary_Emails_Label_Text_' | translate}}
      </label>
    </div>

    <div class="col-md-4 checkbox">
      <label>
        <input id="optInDailyLocationSummaryEmails" formControlName="optInDailyLocationSummaryEmails"
          class="cc-filter-checkbox" type="checkbox" kendoCheckBox />
        {{'_User_Appointment_Settings_Daily_Location_Summary_Emails_Label_Text_' | translate}}
      </label>
    </div>

    <div class="col-md-4 checkbox d-flex flex-column justify-content-center">
      <label>
        <input id="flexibleFloatEmployee" formControlName="flexibleFloatEmployee" class="cc-filter-checkbox"
          (change)="floatEmployeeChange()" [(ngModel)]="isFloat" type="checkbox" kendoCheckBox #floatEmploye />
        {{'_User_Appointment_Settings_Flexible_Float_Employee_Label_Text_' | translate }} <span *ngIf="isFloat">({{this.floatLocationList.length ?  this.floatLocationList.length : '0'}}) {{'_User_Appointment_Settings_Is_Float_Checked_Text_' | translate }}</span>
      </label>

      <div *ngIf="isFloat" class="tab-indent">
        <ng-multiselect-dropdown
        [ngClass]="'cc-multi-select float-multi'"
        formControlName="floatLocations"
        [settings]="dropdownSettings"
        [data]="locationList"
        (onSelect)="onFloatLocationSelect()"
        (onDeSelect)="onFloatLocationDeSelect($event)"
        [placeholder]="locationList.length === 0 ? ('_General_No_Branches_Text_' | translate) : ('_General_Select_Text_' | translate)"
        [(ngModel)]="floatLocationList">
        </ng-multiselect-dropdown>
        <div class="cc-validation" *ngIf="this.floatLocationList.length == 0 && this.locationList.length != 0">
          {{'_User_Appointment_Settings_Flexible_Float_Employee_Validation_Text_' | translate }}
        </div>
      </div>


    </div>
  </div>

  <div class="row">

    <div class="col-md-4 checkbox">
      <label>
        <input id="useAppointments" (change)="useAppointmentsChange()" formControlName="useAppointments"
          class="cc-filter-checkbox" type="checkbox" kendoCheckBox [(ngModel)]="appointmentsEnabled"/>
        {{'_General_Appointments_Text_' | translate}}
      </label>
      <div class="tab-indent cc-inline">
        <label for="assignmentRank">{{'_User_Appointment_Settings_Assignment_Rank_Label_Text_' | translate}}</label>
        <input id="assignmentRank"  class="form-control assignment-rank" formControlName="assignmentRank" type="number"
          min="1" max="99" (keypress)="numbersOnly($event)" (focusout)="onFocusOutAssignmentRank()">
      </div>
    </div>

    <div class="col-md-4 checkbox" *ngIf="acClientConfiguration?.eventsEnabled">
      <label>
        <input id="useEvents" formControlName="useEvents" class="cc-filter-checkbox" type="checkbox" kendoCheckBox />
        {{'_General_Use_Events_Text_' | translate}}
      </label>
    </div>

    <div class="col-md-4 checkbox">
      <label>
        <input id="restrictAvailabilityOperatingHours" formControlName="restrictAvailabilityOperatingHours" class="cc-filter-checkbox" type="checkbox" kendoCheckBox   />
        {{'_User_Appointment_Settings_Restrict_Availability_To_Operating_Hours_Label_Text_' | translate}}
      </label>
    </div>

  </div>

  <div class="row">
    <div class="col-md-4" formGroupName="meetingPreferenceGroup">
      <div class="checkbox">
        <h6 class="sub-heading">{{'_General_Meeting_Preferences_Text_' | translate }}</h6>
        <label for="allowInPersonAppointments" [disableIf]="allowInPersonOnlySelected()"  >
          <input id="allowInPerson" formControlName="allowInPersonAppointments" (change)="allowInPersonAppointmentsChange()"  class="cc-filter-checkbox"
            type="checkbox" kendoCheckBox [disabled]="!appointmentsEnabled"/>
          {{'_User_Appointment_Settings_Allow_In_Person_Appointments_Label_Text_' | translate }}
        </label>
        <label for="allowPhoneAppointments" [disableIf]="allowPhoneOnlySelected()" >
          <input id="allowPhone" formControlName="allowPhoneAppointments" (change)="allowPhoneAppointmentsChange()"  class="cc-filter-checkbox" type="checkbox"
            kendoCheckBox />
          {{'_User_Appointment_Settings_Allow_Phone_Appointments_Label_Text_' | translate }}
        </label>
        <label for="allowVirtualAppointments" [disableIf]="allowVirtualOnlySelected()"  >
          <input id="allowVirtual" formControlName="allowVirtualAppointments" (change)="allowVirtualAppointmentsChange()"  class="cc-filter-checkbox" type="checkbox"
            kendoCheckBox [(ngModel)]="allowVirtualApp"/>
          {{'_User_Appointment_Settings_Allow_Virtual_Appointments_Label_Text_' | translate }}
        </label>
        <div class="cc-validation"
          *ngIf="isAnyMeetingPreferenceOptionNotSelected()">
          {{'_General_Meeting_Preference_Option_Text_' | translate }}
        </div>

        <div class="tab-indent cc-inline" *ngIf="allowVirtualApp">
          <label>{{'_User_Appointment_Settings_Conferencing_Service_Text_' | translate }} {{conferencingProvider}}
            <span *ngIf="(!showExtract && showPopIoValidation == false) && conferencingProviderAuthenticationStatus && isConferencingProviderAuthenticationStatusExtracted" class="fa fa-check-circle authorized" title="{{'_User_Additional_Authorization_Success_Text_' | translate}}"></span>
            <span *ngIf="(!showExtract && showPopIoValidation == false) && !conferencingProviderAuthenticationStatus && isConferencingProviderAuthenticationStatusExtracted" class="fa fa-exclamation-circle unauthorized" title="{{'_User_Additional_Account_Not_Authorize_Text_' | translate}}"></span>
            <span *ngIf="showPopIoValidation && popIoValidationStatus == true" [title]="popIoValidationSuccessTooltip" class="pop-io-status-icon fas fa-check-circle pop-io-validated"></span>
            <span *ngIf="showPopIoValidation && popIoValidationStatus == false" [title]="popIoValidationFailedTooltip" class="pop-io-status-icon fas fa-times-circle pop-io-not-validated"></span>
          </label>
        </div>
        <div *ngIf="showExtract && allowVirtualApp" class="tab-indent">
          <label>{{'_User_Appointment_Settings_Conferencing_USer_Id_Text_' | translate }} {{conferencingUserId}}</label>
          <div class="cc-inline">
            <button class="btn btn-primary" type="button" (click)="doGetConferencingUserId()">
{{ (extracting ? '_User_Appointment_Settings_Meeting_Preferences_Extracting_Button_Text_' : '_User_Appointment_Settings_Meeting_Preferences_Extract_Button_Text_') | translate }}</button>
            <label class="extract-user-id" *ngIf="conferencingUserId == ''">{{'_User_Appointment_Settings_Meeting_Preferences_Extract_Validation_Text_' | translate }}</label>
          </div>
          <div class="cc-validation opt-hours-validation" *ngIf="extractUserIdError">
            {{'_User_Appointment_Settings_Meeting_Preferences_User_Id_Validation_Text_' | translate }}
          </div>
        </div>
        <!--POP/IO-->
        <div *ngIf="showPopIoValidation && allowVirtualApp" class="tab-indent pop-io-settings">
          <div>
            <div class="cc-inline">
              <label>{{'_User_Additional_Settings_Resource_External_Id_Text_' | translate}}<span class="required-field">*</span></label>
              <input class="form-control resource-ext-id" type="text" id="popIoExternalResourceId" formControlName="popIoExternalResourceId" (ngModelChange)="onPopIoExternalResourceIdChange()"/>
            </div>
            <div class="cc-validation" *ngIf="popIoExternalResourceId?.touched && popIoExternalResourceId?.errors?.required">Resource External ID is required</div>
          </div>
          <div class="pop-io-validation-btn-grp">
            <button class="btn btn-primary popio-validate-btn" [disabled]="popIoExternalResourceId?.pristine || popIoValidationStatus || popIoExternalResourceId?.errors?.required" (click)="popIoExternalResourceIdValidation($event)">{{'_User_Additional_Settings_Validate_Text_' | translate}}</button>
            <span class="fas fa-exclamation-circle pop-io-not-validated" *ngIf="popIoResourceExtIdValidated != null && !popIoResourceExtIdValidated && !popIoExternalResourceId?.hasError('required')" [title]="popIoNotValidatedTooltip"></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Button Panel -->
  <div class="cc-btn-panel">
    <button (click)="cancelClicked()" type="button" class="btn btn-secondary">{{'_General_Button_Close_Text_' | translate }}</button>
    <button type="submit" class="btn btn-primary"
    [disabled]="isSaveButtonDisabled()">{{'_General_Button_Save_Text_' | translate }}</button>
  </div>
</form>

<!-- If a user attempts to uncheck a meeting preference option under 'Appointment Settings' pop -->

<kendo-dialog id="reassign-meeting-preference-dialog" [minWidth]="300" [width]="500" title="Confirmation" *ngIf="showReassignPopup" (close)="cancelMeetingPreferenceReassign()">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div>
      <p class="pe-2 mb-2">{{'_User_Appointment_Settings_New_Meeting_Preference_Validation_Text_' | translate }}</p>
  </div>
  <div class="d-flex align-items-center mb-2">
      <h6 class="pe-2">{{'_User_Appointment_Settings_Reassign_To_Label_Text_' | translate }}</h6>
      <kendo-dropdownlist #selected [data]="reassignMeetingPreferenceList" [valueField]="'id'" [textField]="'displayValue'"
      [(ngModel)]="selectedMeetingPreferece" [disabled]="(reassignMeetingPreferenceList.length == 1)">
      </kendo-dropdownlist>
  </div>
  <div>
      <p class="pe-2">{{'_User_Appointment_Settings_New_Meeting_Preference_Message_Text_' | translate }}</p>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
      <button type="button" class="btn btn-primary" (click)="onReassignMeetingPreference()">{{'_General_Action_Label_Yes_Text_' | translate }}</button>
      <button type="button" class="btn btn-secondary" (click)="cancelMeetingPreferenceReassign()">{{'_General_Action_Label_No_Text_' | translate }}</button>
  </kendo-dialog-actions>

</kendo-dialog>
